import ProductsAPI from 'dashboard/api/pipelines/products';
import ProductVariantsAPI from 'dashboard/api/pipelines/productVariants';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getProducts(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, { accountId }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await ProductsAPI.get(accountId);
      commit('SET_ITEMS', response.data?.data || []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, { accountId, product }) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await ProductsAPI.create(accountId, product);
      const created = response.data?.data || response.data;
      commit('ADD_ITEM', created);
      return created;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { accountId, id, product }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ProductsAPI.update(accountId, id, product);
      const updated = response.data?.data || response.data;
      commit('UPDATE_ITEM', updated);
      return updated;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ commit }, { accountId, id }) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await ProductsAPI.delete(accountId, id);
      commit('DELETE_ITEM', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  createVariant: async (_ctx, { accountId, productId, variant }) => {
    const response = await ProductVariantsAPI.create(accountId, productId, variant);
    return response.data?.data || response.data;
  },

  updateVariant: async (_ctx, { accountId, productId, id, variant }) => {
    const response = await ProductVariantsAPI.update(accountId, productId, id, variant);
    return response.data?.data || response.data;
  },

  deleteVariant: async (_ctx, { accountId, productId, id }) => {
    await ProductVariantsAPI.delete(accountId, productId, id);
  },

  createImage: async (_ctx, { accountId, productId, image }) => {
    const response = await ProductsAPI.createImage(accountId, productId, image);
    return response.data?.data || response.data;
  },

  deleteImage: async (_ctx, { accountId, productId, id }) => {
    await ProductsAPI.deleteImage(accountId, productId, id);
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_ITEMS(_state, items) {
    _state.records = Array.isArray(items) ? items : [];
  },

  ADD_ITEM(_state, item) {
    if (!item?.id) return;
    _state.records.unshift(item);
  },

  UPDATE_ITEM(_state, item) {
    const index = _state.records.findIndex(record => record.id === item.id);
    if (index === -1) return;
    _state.records[index] = { ..._state.records[index], ...item };
  },

  DELETE_ITEM(_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
